import * as React from "react";
import { throttle} from 'underscore';

const numParticles = 15;
const difference = function (a, b) { return Math.abs(a - b); }

const later = (delay, value) => {
  let timer = 0;
  let reject = null;
  const promise = new Promise((resolve, _reject) => {
      reject = _reject;
      timer = setTimeout(resolve, delay, value);
  });
  return {
      get promise() { return promise; },
      cancel() {
          if (timer) {
              clearTimeout(timer);
              timer = 0;
              reject();
              reject = null;
          }
      }
  };
};

class MusicPlayer extends React.Component {

  constructor(props) {
    super(props);
    this.mouseRef = React.createRef();
  }

  state = {
    index: 0,
    currentTime: '0:00',
    musicList: [{name:'Would you have a little sister?', author: 'itacore', audio:'https://cdn.filestackcontent.com/ka4V39jHSLCvMX3f3Fvm', duration: '3:03'}, 
      {name:'Cyborg Pet', author: 'itacore',  audio:' https://cdn.filestackcontent.com/p3FzslJTmio62COjqQ1T', duration: '2:01'},
      {name:'BUNNY BERZERKER', author: 'itacore',  audio:'https://cdn.filestackcontent.com/pEIFvfJJQNqYFQCWwWET', duration: '3:33'},
      {name:'Flesh-Metal Angel', author: 'itacore',  audio:'https://cdn.filestackcontent.com/vtPgLTbHQlqhCbVloQCz', duration: '1:56'},
      {name:'Heart Spire', author: 'itacore',  audio:'https://cdn.filestackcontent.com/I5rjJIH0TaiPeHDI52wJ', duration: '3:09'}],
    pause: false,
  };

  generateParticle=(e)=>{
     
    [1].forEach(function(i) {
      var j = (1 - i) * 10;
      var elem = document.createElement('div');
      var size = 15 + 'px';
      elem.classList.add('star-elem');
      elem.style.position = 'fixed';
      elem.style.top = e.pageY + Math.round(Math.random() * j - j / 2) + 'px';
      elem.style.left = e.pageX + Math.round(Math.random() * j - j / 2) + 'px';
      elem.style.width = size;
      elem.style.height = size;
      // elem.style.background = 'yellow';
      elem.style.pointerEvents = 'none';
      later(document.body.appendChild(elem),100);
  
      window.setTimeout(function() {
        document.body.removeChild(elem);
      }, 1000);
    });
  }

  throttleGenerate=e=>{
    const {x,y} = e;
    // console.log('difference', difference(e.x,mouseRef.current.x), 'ex', e.x, 'pos.x', mouseRef.current.x)
    // console.log('mosueRef currrent', mouseRef.current);
  
    if(difference(e.x,this.mouseRef.current.x) > 20 || difference(e.y, this.mouseRef.current.y) > 20){
          this.generateParticle(e);
          this.mouseRef.current = {x:e.x,y:e.y};
    }
   
  }


 componentDidMount() {
   this.playerRef.addEventListener("timeupdate", this.timeUpdate, false);
   this.playerRef.addEventListener("ended", this.nextSong, false);
   this.timelineRef.addEventListener("click", this.changeCurrentTime, false);
   this.timelineRef.addEventListener("mousemove", this.hoverTimeLine, false);
   this.timelineRef.addEventListener("mouseout", this.resetTimeLine, false);
   this.mouseRef.current = {x:0,y:0};
   window.addEventListener('mousemove', throttle(this.throttleGenerate, 100), false);
   
 }

  componentWillUnmount() {
    this.playerRef.removeEventListener("timeupdate", this.timeUpdate);
    this.playerRef.removeEventListener("ended", this.nextSong);
    this.timelineRef.removeEventListener("click", this.changeCurrentTime);
    this.timelineRef.removeEventListener("mousemove", this.hoverTimeLine);
    this.timelineRef.removeEventListener("mouseout", this.resetTimeLine);
    window.removeEventListener('mousemove', this.throttleGenerate, false);
  }

changeCurrentTime = (e) => {
  const duration = this.playerRef.duration;
  
  const playheadWidth = this.timelineRef.offsetWidth;
  const offsetWidht = this.timelineRef.offsetLeft;
  const userClickWidht = e.clientX - offsetWidht;
 
  const userClickWidhtInPercent = (userClickWidht*100)/playheadWidth;

  this.playheadRef.style.width = userClickWidhtInPercent + "%";
  this.playerRef.currentTime = (duration * userClickWidhtInPercent)/100;
}

hoverTimeLine = (e) => {
  const duration = this.playerRef.duration;
  
  const playheadWidth = this.timelineRef.offsetWidth
  
  const offsetWidht = this.timelineRef.offsetLeft;
  const userClickWidht = e.clientX - offsetWidht;
  const userClickWidhtInPercent = (userClickWidht*100)/playheadWidth;

  if(userClickWidhtInPercent <= 100){
    this.hoverPlayheadRef.style.width = userClickWidhtInPercent + "%";
  }
  
  const time = (duration * userClickWidhtInPercent)/100;
  
  if( (time >=0) && (time <= duration)){
    this.hoverPlayheadRef.dataset.content = this.formatTime(time);
  }
}

resetTimeLine = () => {
  this.hoverPlayheadRef.style.width = 0;
}

timeUpdate = () => {
  const duration = this.playerRef.duration;
  const timelineWidth = this.timelineRef.offsetWidth - this.playheadRef.offsetWidth;
  const playPercent = 100 * (this.playerRef.currentTime / duration);
	this.playheadRef.style.width = playPercent + "%";
  const currentTime = this.formatTime(parseInt(this.playerRef.currentTime));  
  this.setState({ 
    currentTime 
  });
}

formatTime = (currentTime) =>{
  const minutes = Math.floor(currentTime / 60);
  let seconds = Math.floor(currentTime % 60);

  seconds = (seconds >= 10) ? seconds : "0" + seconds % 60;
  
  const formatTime = minutes + ":" +  seconds
 
  return formatTime;
  }

  updatePlayer = () =>{
    const { musicList, index } = this.state;
    const currentSong = musicList[index];
    const audio = new Audio(currentSong.audio);
    this.playerRef.load();
  }
  
  nextSong = () => {
    const { musicList, index, pause } = this.state;
  
    this.setState({ 
      index: (index + 1) % musicList.length
    });
    this.updatePlayer();
    if(pause){
      this.playerRef.play();
    }
  };

  lastSong=()=>{
    const { musicList, index, pause } = this.state; 
    this.setState({ 
      index: musicList.length - 1
    });
    this.updatePlayer();
    if(pause){
      this.playerRef.play();
    } 
  }

  firstSong=()=>{
    const { musicList, index, pause } = this.state; 
    this.setState({ 
      index: 0
    });
    this.updatePlayer();
    if(pause){
      this.playerRef.play();
    } 
  }

  prevSong = () => {
    const { musicList, index, pause } = this.state;  
    
    this.setState({ 
      index: (index + musicList.length - 1) % musicList.length
    });
    this.updatePlayer();
    if(pause){
      this.playerRef.play();
    }
  };
   

  playOrPause = () =>{
    const { musicList, index, pause } = this.state;
    const currentSong = musicList[index];
    const audio = new Audio(currentSong.audio);
    if( !this.state.pause ){
      this.playerRef.play();
    }else{
      this.playerRef.pause();
    }
    this.setState({
      pause: !pause
    })
  }
  
  clickAudio = (key) =>{
    const { pause } = this.state;
    
    this.setState({
      index: key
    });
    
    this.updatePlayer();
    if(pause){
      this.playerRef.play();
    }
  }

  handleDownloadLink=e=>{
    window.open('https://drive.google.com/file/d/1S0UhLKBpr54txuvoa88Z69oINLd1jHcj/view?usp=sharing', "_blank")
  }

  handleHomeLink=e=>{
    window.open('https://ita.toys/', "_blank")
  }

  
  render() {
    const { musicList, index, currentTime, pause } = this.state;
    const currentSong = musicList[index];
 
    if(musicList[index] === 0 ){

    }
    return (
      <>

      <div className="itacore-title"><img src={`${process.env.PUBLIC_URL}/assets/itacore_title3.png`}></img></div>
      <div className="card">
        
        <div className="flower-bg-base">
  

        <div className="play-list" >
          {musicList.map( (music, key=0) =>
                         <div key={key} 
                           onClick={()=>this.clickAudio(key)}
                           className={"track " + 
                             (index === key && !pause ?'current-audio':'') + 
                             (index === key && pause ?'play-now':'')} >
                           
                           {/* <img className="track-img" src={music.img}/> */}
                           <div className="track-discr" >
                             <span className="track-name" ><TrackName currentSong={currentSong.name} trackName={music.name} /></span>
                             
                           </div>
                        
                         </div>
                        )}
        </div>
        {/* <div className="flower-bg-base copy"></div> */}
        <div onClick={this.handleHomeLink} className="left-grey-button"></div>
        <div onClick={this.handleDownloadLink} className="right-grey-button"></div>
        <div className="controls">
           <button onClick={this.playOrPause} className={!pause ? "play current-btn" : "pause current-btn"}>
            </button>
            <button onClick={this.firstSong} className="first-button"/>
            <button onClick={this.prevSong} className="previous-button"/>
            <button onClick={this.nextSong} className="next-button" />
            <button onClick={this.lastSong} className="last-button"/>
          
          </div>
          <div className="current-song">
          <audio ref={ref => this.playerRef = ref}>
            <source src={ currentSong.audio }  type="audio/mp4"/>
              Your browser does not support the audio element.
          </audio>  
          <div className="time">
            <div className="current-time">{ currentTime }</div>
            <div className="end-time">{ currentSong.duration }</div>
          </div>
          
          <div ref={ref => this.timelineRef = ref} id="timeline" className="svg-normal-mask">
            <div ref={ref => this.playheadRef = ref} id="playhead"></div>
            <div ref={ref => this.hoverPlayheadRef = ref} className="hover-playhead" data-content="0:00"></div>
          </div>
          
      
          
        </div>
        </div>
     
     
     
       
       
      </div>
      <div className="download-section">
        <img src={`${process.env.PUBLIC_URL}/assets/chatting-1.png`}></img>
      </div>
      </>
    )
  }
}


const TrackName = props => {
  let trackPath;
  let trackOptions={};
  let isCurrentTrack = props.currentSong == props.trackName;
  switch(props.trackName){
    case "Would you have a little sister?":
      trackPath = isCurrentTrack ? 'track1-2.png' : 'track1-1.png';
      trackOptions = {width:'240px'}
    break;
    case "Cyborg Pet":
      trackPath = isCurrentTrack ? 'track2-2.png' : 'track2-1.png';
      trackOptions = {width:'154px'}
    break;
    case "BUNNY BERZERKER":
      trackPath =  isCurrentTrack ? 'track3-2.png' : 'track3-1.png';
      trackOptions = {width:'198px', marginTop:'-4px'}
       break;
    case "Flesh-Metal Angel":
      trackPath =  isCurrentTrack ? 'track4-2.png' : 'track4-1.png';
      trackOptions = {width:'198px', marginTop:'-8px'}
    break;  
    case "Heart Spire":
      trackPath = isCurrentTrack ? 'track5-2.png' : 'track5-1.png';
      trackOptions = {width:'143px', marginTop:'-8px'}
    break;
    default: 
    trackPath = ''; 
  }
  return(
    <img src={`${process.env.PUBLIC_URL}/assets/${trackPath}`} style={trackOptions}></img>
  )
}
export default MusicPlayer;
